export const PROJECT_REQUEST = 'PROJECT_REQUEST';
export const PROJECT_SUCESS = 'PROJECT_SUCESS';
export const PROJECT_ERROR = 'PROJECT_ERROR';
export const PROJECT_RESET = 'PROJECT_RESET';

export const UPDATE_PROJECT_REQUEST = 'UPDATE_PROJECT_REQUEST';
export const UPDATE_PROJECT_SUCESS = 'UPDATE_PROJECT_SUCESS';
export const UPDATE_PROJECT_ERROR = 'UPDATE_PROJECT_ERROR';
export const UPDATE_PROJECT_RESET = 'UPDATE_PROJECT_RESET';

export const GET_PROJECT_REQUEST = 'GET_PROJECT_REQUEST';
export const GET_PROJECT_SUCESS = 'GET_PROJECT_SUCESS';
export const GET_PROJECT_ERROR = 'GET_PROJECT_ERROR';

export const SEARCH_PROJECT_REQUEST = 'SEARCH_PROJECT_REQUEST';
export const SEARCH_PROJECT_SUCESS = 'SEARCH_PROJECT_SUCESS';
export const SEARCH_PROJECT_ERROR = 'SEARCH_PROJECT_ERROR';

export const DELETE_PROJECT_REQUEST = 'DELETE_PROJECT_REQUEST';
export const DELETE_PROJECT_SUCESS = 'DELETE_PROJECT_SUCESS';
export const DELETE_PROJECT_ERROR = 'DELETE_PROJECT_ERROR';
export const DELETE_PROJECT_RESET = 'DELETE_PROJECT_RESET';

export const SEARCH_USER_PROJECT_REQUEST = 'SEARCH_USER_PROJECT_REQUEST';
export const SEARCH_USER_PROJECT_SUCESS = 'SEARCH_USER_PROJECT_SUCESS';
export const SEARCH_USER_PROJECT_ERROR = 'SEARCH_USER_PROJECT_ERROR';

export const SEARCH_PROJECT_BY_MONTH_REQUEST = 'SEARCH_PROJECT_BY_MONTH_REQUEST';
export const SEARCH_PROJECT_BY_MONTH_SUCESS = 'SEARCH_PROJECT_BY_MONTH_SUCESS';
export const SEARCH_PROJECT_BY_MONTH_ERROR = 'SEARCH_PROJECT_BY_MONTH_ERROR';
export const SEARCH_PROJECT_BY_MONTH_RESET = 'SEARCH_PROJECT_BY_MONTH_RESET';
